// extracted by mini-css-extract-plugin
export var hidden = "_q2-1";
export var visible = "_q2-0";